import { Typography } from '@mui/material'
import { HTMLAttributes } from 'react'
import { Link } from 'react-router-dom'
import { sumMenuItemStyle } from 'src/features/globalNavigation/components/subMenuItem/subMenuItemStyle'

type SubMenuItemInternalLinkProps = {
  /**
   * 内部リンク
   * e.g. `/dashboards
   */
  internalPath: string
  title: string
} & HTMLAttributes<HTMLElement>

/**
 * グローバルナビゲーションのサブメニュー内の個々のアイテム (内部リンク)
 */
export const SubMenuItemInternalLink: React.FC<SubMenuItemInternalLinkProps> = (
  props: SubMenuItemInternalLinkProps,
) => {
  const { internalPath, title, ...restProps } = props

  return (
    <Link
      {...restProps}
      css={sumMenuItemStyle.container}
      to={internalPath}
      aria-label={title}
    >
      <Typography variant="subtitle2" component="span">
        {title}
      </Typography>
    </Link>
  )
}
